import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.list-report-access-secondary-categories.ReportAccessSecondaryCategoryListPresenter`

export default defineMessages({
  fetchErrorToastTitle: {
    id: `${scope}.fetchErrorToastTitle`,
    defaultMessage: 'Error',
  },
  fetchErrorToastMessage: {
    id: `${scope}.fetchErrorToastMessage`,
    defaultMessage:
      'Unable to load {pluralSecondaryOrgCategoryLabel}. Please try again.',
  },
})
